import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { EmploymentsQuery as EmploymentsQueryType, EmploymentsQueryVariables } from "./__generated__/EmploymentsQuery";

const EmploymentsQuery = loader("./EmploymentsQuery.gql");

type EmploymentsQueryProviderType = (props: {
  children: (data: EmploymentsQueryType) => ReactNode;
  variables: EmploymentsQueryVariables;
}) => ReactElement;

export const EmploymentsQueryProvider: EmploymentsQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<EmploymentsQueryType, EmploymentsQueryVariables>(EmploymentsQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
